import { INDEXED_SEARCH_PATH } from 'constants/main';
import categoryNameConstruct from 'utils/categoryNameConstruct';
import { TEMPLATES_REQUEST_LIMIT } from '../pages/Categories/constants';
import { TemplatesResponseModel } from './types';

const queryStringParams = ['theme'];

export default async function getTemplates(
  category: string,
  subCategory: string,
  searchParams: URLSearchParams,
  headers?: any,
): Promise<TemplatesResponseModel> {
  const { finalCategory } = categoryNameConstruct(category, subCategory);
  const baseUrl = `${process.env.REACT_APP_API_URL}/content-category-items/template/${finalCategory}`;
  const path =
    subCategory && category !== INDEXED_SEARCH_PATH ? `${baseUrl}/${subCategory}` : baseUrl;
  const size = searchParams.get('size');

  searchParams.set('limit', String(TEMPLATES_REQUEST_LIMIT));

  if (!searchParams.has('page')) {
    searchParams.set('page', '1');
  }

  const combinedValues = [
    searchParams.get('q'),
    ...queryStringParams.map(param => searchParams.get(param)),
  ]
    .filter(Boolean)
    .join(',');

  if (combinedValues) {
    searchParams.set('q', combinedValues);
  } else {
    searchParams.delete('q');
  }

  queryStringParams.forEach(param => searchParams.delete(param));

  if (size) {
    const normalizedSize = size.replaceAll(' ', '-');
    searchParams.set('ratio', normalizedSize);
  }

  const query = searchParams.toString();

  const url = `${path}?${query}`;

  const res = await fetch(url, {
    headers,
  });

  if (!res.ok) {
    throw new Error(`Status error fetching ${path}: ${res.status}`);
  }

  return res.json();
}
